(function () {
  // If this file ever loads twice, only run once.
  if (window.__minimogCouponPatch) return;
  window.__minimogCouponPatch = true;

  var root = window.Shopify.routes.root;
  var SAVE_COUPON = '.m-cart-addon--save[data-action="coupon"]';
  var PANEL = '#m-addons-coupon';
  var INPUT = '[data-coupon-code-input]';
  var NOTI  = '[data-discount-noti]';

  // Clear the old "stuck" code storage.
  try { localStorage.removeItem('minimog-discount-code'); } catch (e) {}

  // Catch the coupon Save click before the old broken handler runs.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(SAVE_COUPON);
    if (!btn) return;                 // not the coupon button -> ignore
    e.preventDefault();
    e.stopImmediatePropagation();     // block the old handler
    applyCoupon(btn.closest(PANEL), btn);
  }, true);

  function applyCoupon(panel, btn) {
    var input = panel.querySelector(INPUT);
    var code = (input.value || '').trim();
    btn.disabled = true;

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })   // empty string = remove all codes
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var applied = !code || codes.some(function (d) {
          return d.code.toLowerCase() === code.toLowerCase() && d.applicable;
        });

        rerender();
        syncNoti(cart);

        if (applied) {
          setMsg(panel, '');
          closePanel(btn);
        } else {
          setMsg(panel, (window.MinimogStrings && window.MinimogStrings.discountError) || 'This code is not valid for your cart.');
        }
      })
      .catch(function () {
        setMsg(panel, 'Something went wrong. Please try again.');
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  function rerender() {
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer && drawer.onCartDrawerUpdate) drawer.onCartDrawerUpdate();
    var main = document.querySelector('m-cart');
    if (main && main.onCartUpdate) main.onCartUpdate();
  }

  function syncNoti(cart) {
    var has = (cart.discount_codes || []).some(function (d) { return d.applicable; });
    document.querySelectorAll(NOTI).forEach(function (el) {
      el.style.display = has ? 'inline' : 'none';
    });
  }

  function setMsg(panel, msg) {
    var input = panel.querySelector(INPUT);
    var el = panel.querySelector('[data-coupon-msg]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-coupon-msg', '');
      el.className = 'm-cart-addon-message-error';
      input.after(el);
    }
    el.textContent = msg;
  }

  function closePanel(btn) {
    var action = btn.closest('.m-cart-addon__action');
    var closeBtn = action && action.querySelector('.m-cart-addon--close[data-action="coupon"]');
    if (closeBtn) closeBtn.click();
  }

  // Pre-fill the field + dot from the real cart when the drawer opens.
  function hydrate() {
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var active = (cart.discount_codes || []).find(function (d) { return d.applicable; });
        if (active) {
          document.querySelectorAll(INPUT).forEach(function (i) { i.value = active.code; });
        }
        syncNoti(cart);
      })
      .catch(function () {});
  }

  if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents && window.MinimogTheme.pubSubEvents.openCartDrawer) {
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, hydrate);
  }
  document.addEventListener('DOMContentLoaded', hydrate);
})();